import React from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import SubHeadline from './SubHeadline'

const CryptorTag = () => {
  return (
    <div>
      <SubHeadline>暗号化タグ(仮)</SubHeadline>
      <section>
        <SyntaxHighlighter language="html">
          {`
<script type="text/javascript">
  (function(link, name, code){
    var n = document.getElementById(name)
    var c = document.getElementById(code)
    var a = document.getElementById(link)
    var xhr = new XMLHttpRequest()
    xhr.open('POST', 'http://localhost:13000/rest/encrypt', false)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.send('name=\${n.value}&code=\${c.value}')
    res = JSON.parse(xhr.response)
    a.href = "https://?name=" + res.name + "&code=" + res.code + "&cr=true"
  })
</script>
          `}
        </SyntaxHighlighter>
      </section>
    </div>
  )
}

export default CryptorTag
